module.exports = __webpack_public_path__ + "static/img/1-06-2.3152e62.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/1-06-2.png
// module id = y40H
// module chunks = 1